// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';
import { selectStepsProgresses } from '../../feature';

// Modules
import { AttendeesList, groupViewingAttendeesByDate } from '@/modules/Viewing';

// Models
import { ViewingStepProgress } from '@/models/propertyProgress.model';
import { StepType } from '@/models/step.model';

// Components
import { ResetStepButton, StepCard, StyledRow, StyledText } from '../../components';

// Helpers
import { finalStatuses, getViewingUrl } from '../../helpers';

type TViewingProgressContainerProps = {
  hideResetButton?: boolean;
};

const ViewingProgressContainer = ({ hideResetButton = false }: TViewingProgressContainerProps) => {
  const { t } = useTranslation('property');
  const stepsProgresses = useAppState(selectStepsProgresses);
  const viewingProgress = stepsProgresses?.[StepType.VIEW] as ViewingStepProgress;

  const viewingUrl = getViewingUrl(viewingProgress?.property_id);

  if (!viewingProgress) return null;

  const scheduleRecords = groupViewingAttendeesByDate(viewingProgress?.signups ?? []);

  return (
    <StepCard title={t('step_viewing')} status={viewingProgress.status}>
      {!!viewingUrl && (
        <StyledRow>
          <StyledText>
            {t('viewing_signup_link')}
            <a href={viewingUrl} target={'_blank'} rel="noreferrer">
              {viewingUrl}
            </a>
          </StyledText>
        </StyledRow>
      )}
      <StyledRow>
        {!hideResetButton && finalStatuses.includes(viewingProgress.status) && (
          <ResetStepButton
            propertyId={viewingProgress?.property_id}
            stepName={StepType.VIEW}
            shouldResetStepData={false}
          />
        )}
      </StyledRow>
      <AttendeesList scheduleRecords={scheduleRecords} />
    </StepCard>
  );
};

export default ViewingProgressContainer;
